import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { Title } from '@angular/platform-browser';

export const titleResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot) => {
  const titleService = inject(Title);
  const title = route.queryParams['title'] || 'MLI Education';
  titleService.setTitle(title);
  return title;
};
